module.exports = __webpack_public_path__ + "static/textarea-placeholder-do-042a390777b94c3b802c0229c9e64278.png";